import './App.css';
import {Component} from "react";
import axios from "axios";


class App extends Component {
    constructor(props) {
        super(props);

        const {redirectUrl} = window.config;
        this.redirectUrl = redirectUrl;

        this.state = {
            phone: '',
            captcha: '',
            captchaTimeCount: 0,
            errorMessage: ''
        }
    }

    componentDidMount() {
    }

    onPhoneChange = (e) => {
        this.setState((prevState) => {
            return {
                phone: e.target.value
            }
        });
    }

    clearPhone = () => {
        this.setState((prevState) => {
            return {
                phone: ''
            }
        });
        document.getElementById("phoneInput").focus();
    }

    onCaptchaChange = (e) => {
        this.setState((prevState) => {
            return {
                captcha: e.target.value
            }
        });
    }

    validatePhone = () => {
        return /^\d{11}$/.test(this.state.phone);
    }

    validateCaptcha = () => {
        return /^\d{6}$/.test(this.state.captcha);
    }

    canSendCaptcha = () => {
        return this.validatePhone() && this.state.captchaTimeCount === 0;
    }

    onSendCaptchaClicked = () => {
        if (!this.canSendCaptcha()) {
            return;
        }
        this.setState((prevState) => {
            return {
                errorMessage: ""
            }
        });

        axios.post(
            "/account_service/passport/phoneLogin/sendSmsCaptcha",
            {
                phone: this.state.phone,
                scenario: 1//登录场景
            }
        ).then((response) => {
            if (response.data.code === 0) {
                this.setState((prevState) => {
                    return {
                        captchaTimeCount: 60
                    }
                });

                const intervalId = setInterval(() => {
                    this.setState((prevState) => {
                        return {
                            captchaTimeCount: prevState.captchaTimeCount - 1
                        }
                    });
                }, 1000);

                setTimeout(() => {
                    clearInterval(intervalId);
                }, 60000);
            } else {
                this.setState((prevState) => {
                    return {
                        errorMessage: response.data.msg
                    }
                });
            }
        }).catch((error) => {
            console.log(error);
            this.setState((prevState) => {
                return {
                    errorMessage: "发送验证码失败"
                }
            });
        });
    }

    onPhoneLoginClicked = () => {
        this.setState((prevState) => {
            return {
                errorMessage: ""
            }
        });

        axios.post(
            "/account_service/passport/phoneLogin/login",
            {
                phone: this.state.phone,
                captcha: this.state.captcha,
                scenario: 1,//登录场景
                redirectUrl: this.redirectUrl
            }
        ).then((response) => {
            if (response.data.code === 0) {
                window.location.href = response.data.data;
            } else {
                this.setState((prevState) => {
                    return {
                        errorMessage: response.data.msg
                    }
                });
            }
        }).catch((error) => {
            console.log(error);
            this.setState((prevState) => {
                return {
                    errorMessage: "登录失败"
                }
            });
        });
    }

    render() {
        return (
            <div className="App">
                <div className="h5_head"></div>
                <div className="loginPanel">
                    <div className="title">
                        <div className="title_text">验证码登录</div>
                    </div>
                    <div className="input_form">
                        <div className="input_form_item">
                            <input className="input_text" name="phone" id="phoneInput"
                                   placeholder="请输入手机号"
                                   value={this.state.phone}
                                   onChange={this.onPhoneChange} maxLength={11}/>

                            <svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle"
                                 width="1em"
                                 height="1em" fill="currentColor" aria-hidden="true"
                                 className="closeIcon"
                                 onClick={this.clearPhone}
                                 style={{"display": this.state.phone ? "block" : "none"}}>
                                <path
                                    d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path>
                            </svg>
                        </div>
                        <div className="input_form_item">
                            <input className="input_text" name="captcha" value={this.state.captcha}
                                   placeholder="请输入验证码"
                                   onChange={this.onCaptchaChange} maxLength={6}/>
                            {
                                this.state.captchaTimeCount > 0 ?
                                    <span
                                        className="sendCaptcha sendCaptcha_disabled">{this.state.captchaTimeCount}s后重新发送</span>
                                    :
                                    this.canSendCaptcha() ?
                                        <span className="sendCaptcha"
                                              onClick={this.onSendCaptchaClicked}>获取验证码</span>
                                        :
                                        <span className="sendCaptcha sendCaptcha_disabled">获取验证码</span>
                            }
                        </div>
                        <div className="error_tips">{this.state.errorMessage}</div>
                    </div>
                    <div className="login_button_item">
                        <button
                            disabled={this.validatePhone() && this.validateCaptcha() ? "" : "disabled"}
                            onClick={this.onPhoneLoginClicked}
                        >登录
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default App;
